export default {
  IRR: 'ریال',
  IRT: 'تومان'
}
